import { render, staticRenderFns } from "./FormProtocolQuery.vue?vue&type=template&id=38fa3730&scoped=true&"
import script from "./FormProtocolQuery.vue?vue&type=script&lang=js&"
export * from "./FormProtocolQuery.vue?vue&type=script&lang=js&"
import style0 from "./FormProtocolQuery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FormProtocolQuery.vue?vue&type=style&index=1&id=38fa3730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa3730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38fa3730')) {
      api.createRecord('38fa3730', component.options)
    } else {
      api.reload('38fa3730', component.options)
    }
    module.hot.accept("./FormProtocolQuery.vue?vue&type=template&id=38fa3730&scoped=true&", function () {
      api.rerender('38fa3730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/protocol/FormProtocolQuery.vue"
export default component.exports